<template>
    <div class="delivery-screenSaver-detail">
        <el-row class="device-drink-title">
            <el-col :span="8">
                <span class="h3">{{$t('dai_ji_ping_bao_bian_ji')}}</span>
                <router-back/>
            </el-col>
        </el-row>
        <el-row class="screen-saver-data" :gutter="10">
            <el-col  class="delivery-screen-saver-picture">
                <multi-upload class="upload" :urls="screenSaver.urls" :tip="$t('xian_zhi_fen_bian_lv_can_kao_ji_xing_fen_bian_lv_shou_ce')"
                              ref="mulUpload"
                              :listType="'picture-card'"
                              :uploadSuccess="uploadSuccess"></multi-upload>
            </el-col>
            <el-col class="device-drink-data-list">
                <div>
                    <span class="device-title">{{$t('xiang_guan_she_bei')}}</span>
                    <el-button size="mini" type="primary" @click="allocatedVisible=true">{{$t('bang_ding_she_bei')}}</el-button>
                    <el-button size="mini" type="primary" @click="updateScreenSaver">{{$t('bao_cun_ping_bao')}}</el-button>
                </div>
                <el-table :data="devices">
                    <el-table-column :label="$t('she_bei_ming_cheng')" align="center" prop="name"></el-table-column>
                    <el-table-column :label="$t('she_bei_bian_hao')" align="center" prop="uuid"></el-table-column>
                    <el-table-column :label="$t('chan_pin_ming_chen')" align="center" prop="productName"></el-table-column>
                    <el-table-column :label="$t('cao_zuo')" align="center" prop="name">
                        <template slot-scope="scope">
                        <span @click="handleDelete(scope.row)"
                              class="device-screen-saver-edit">{{$t('shan_chu')}}</span>

                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        @current-change="handleCurrentChange"
                        class="pagination"
                        :current-page="pagination.curPage"
                        :page-size="pagination.limit"
                        layout="total, prev, pager, next, jumper"
                        :total="pagination.total">
                </el-pagination>

            </el-col>

        </el-row>

        <c-dialog class="dialog" :visible.sync="allocatedVisible" :width="'50rem'" :height="'37.5rem'"
                  :outer-close="false"
                  :title="$t('fen_pei_she_bei')">

            <el-button slot="title" size="mini" type="primary" @click="deviceAllocate">{{$t('bao_cun')}}</el-button>

            <allocation-device ref="allocDevice" slot="default"></allocation-device>
        </c-dialog>

    </div>

</template>

<script>
    import CDialog from '@/components/Dialog'
    import MultiUpload from '@/components/MultiUpload'
    import AllocationDevice from '@/components/AllocateDevice'
    import {
        screenSaverUpdate,
        screenSaverDeviceUnion,
        screenSaverDeviceList,
        screenSaverDeviceBind,
        screenSaverDeviceUnBind
    } from '@/api/delivery/device/screenSaver'
    export default {
        name: '',
        components: {
            MultiUpload,
            CDialog,
            AllocationDevice
        },
        activated: function () {
            this.pagination.uuid = this.$route.params.uuid
            for (let item in this.$route.params) {
                if (this.screenSaver.hasOwnProperty(item)) {
                    this.screenSaver[item] = this.$route.params[item]
                }
            }
            this.$refs.mulUpload.setUrls(this.screenSaver.urls)
            this.loadDevices()
        },
        data: function () {
            return {
                screenSaver: {
                    uuid: '',
                    urls: [],
                },
                devices: [],
                allocatedVisible: false,
                pagination: {
                    uuid: '',
                    start: 0,
                    curPage: 1,
                    limit: 10,
                    total: 0,
                },
            }
        },
        methods: {
            handleCurrentChange(value){
                this.pagination.curPage = value
                this.pagination.start = (value - 1) * this.pagination.limit
                screenSaverDeviceList(this.pagination).then(res => {
                    this.devices = res.data
                })
            },

            updateScreenSaver() {
                this.$refs.mulUpload.handleUpload()
            },

            deviceAllocate(){
                let vue = this
                let devices = vue.$refs.allocDevice.deviceAllocate()
                if (!devices.length) {
                    this.$message.warning('请选取需要分配的设备')
                } else {
                    screenSaverDeviceBind({uuid: this.pagination.uuid, deviceUuids: devices}).then(() => {
                        vue.loadDevices()
                        vue.allocatedVisible = false
                    })
                }
            },

            loadDevices() {
                let vue = this
                screenSaverDeviceUnion(this.pagination).then(res => {
                    vue.devices = res.data.list || []
                    vue.pagination.total = parseInt(res.data.total)
                })
            },


            handleDelete(row) {
                this.$confirm('此操作将删除设备屏保, 是否继续?', this.$t('ti_shi'), {
                    confirmButtonText: this.$t('que_ding'),
                    cancelButtonText: this.$t('qu_xiao'),
                    type: 'warning'
                }).then(() => {
                    screenSaverDeviceUnBind({deviceUuid: row.uuid, uuid: this.pagination.uuid}).then(res => {
                        if (res.code === 0) {
                            this.$message.success('移除成功')
                            this.loadDevices()
                        }
                    })
                }).catch(() => {

                })
            },
            uploadSuccess(urls){
                if (urls.length ===0){
                    this.$message.warning('屏保图片最少一张')
                    return
                }
                this.screenSaver.urls = urls
                screenSaverUpdate(this.screenSaver).then(() => {
                    this.$message.success('更新成功')
                })
            }
        },
    }
</script>

<style lang="scss">
    .delivery-screenSaver-detail {
        .delivery-screen-saver-picture{
            margin-bottom: $padding;
            overflow-y: scroll;
            .upload{
                .upload-info{
                    height: 8rem;
                }
            }
        }

        .device-screen-saver-edit{
            color: $btn_sec_color;
            cursor: pointer;
        }

        .device-title{
            margin-right: $padding;
        }

    }
</style>
